import React from "react";
import { Container, Row, Col, Popover } from "react-bootstrap";
import { BsArrowRight } from "react-icons/bs";
import MediaQuery from "react-responsive";
import './Blc_map.css';

const Blc_map = () => {
  return (
    <section>
    <Container>
      <Row>
        <Col lg={6} sm={12}>
          <div className="pos-center">
            <h2
              className="text-center mb-3 map-title"
            >
              18 Branches
              <br />
              across
              <br />
              Bangladesh
            </h2>
            <h6 className="px-4 find-us text-center mt-4">
              Find Us <BsArrowRight size={28} />
            </h6>
          </div>
        </Col>


        <MediaQuery minWidth={700}>
          <Col lg={6} sm={12}>
            <div className="pos-center">
              <div className="main-img">
                <div className="invisible-area dinajpur">
                  <div className="tooltips">
                    <Popover id="popover-basic">
                      <Popover.Header as="h3">Dinajpur</Popover.Header>
                      <Popover.Body>
                        <strong>  Address: </strong> Uttara Sadipur, PO: HSTU, Upazilla: Dinajpur Sadar, Dinajpur-5200<br />
                        <strong>Phone: </strong>01730351115
                      </Popover.Body>
                    </Popover>
                  </div>
                </div>
                <div className="invisible-area rangpur">
                  <div className="tooltips">
                    <Popover id="popover-basic">
                      <Popover.Header as="h3">Rangpur</Popover.Header>
                      <Popover.Body>
                        <strong> Address: </strong> RK Road, Darshanamor,PO: Cadet College, Ghagatpara, Rangpur-5400<br />
                        <strong>Phone: </strong>01730351117
                      </Popover.Body>
                    </Popover>

                  </div>
                </div>
                <div className="invisible-area rajshahi">
                  <div className="tooltips">
                    <Popover id="popover-basic">
                      <Popover.Header as="h3">Rajshahi</Popover.Header>
                      <Popover.Body>
                        <strong> Address: </strong> Bhaiya, Airport Road, Vugrail, PO: Paba, Thana: Paba, Rajshahi-6210<br />
                        <strong>Phone: </strong>  01730351132
                      </Popover.Body>
                    </Popover>
                  </div>
                </div>
                <div className="invisible-area bogura">
                  <div className="tooltips">
                    <Popover id="popover-basic">
                      <Popover.Header as="h3">Bogura</Popover.Header>
                      <Popover.Body>
                        <strong> Address: </strong> Betgari, PO: Banani, Upazilla: Shahajanpur, Bogura-5600<br />
                        <strong>Phone: </strong>01730346310
                      </Popover.Body>
                    </Popover>
                  </div>
                </div>
                <div className="invisible-area pabna">
                  <div className="tooltips">
                    <Popover id="popover-basic">
                      <Popover.Header as="h3">Pabna</Popover.Header>
                      <Popover.Body>
                        <strong> Address: </strong> Chakramanandpur, Gachpara, Pabna-6600<br />
                        <strong>Phone: </strong>01729071550
                      </Popover.Body>
                    </Popover>
                  </div>
                </div>
                <div className="invisible-area-mymensingh mymensingh">
                  <div className="tooltips">
                    <Popover id="popover-basic">
                      <Popover.Header as="h3">Mymensingh</Popover.Header>
                      <Popover.Body>
                        <strong> Address: </strong> Char Kalibari, Sherpur Road, PO:Lalkuthi Darbar, Mymensingh-2200<br />
                        <strong>Phone: </strong> 01730351109
                      </Popover.Body>
                    </Popover>
                  </div>
                </div>
                <div className="invisible-area madhupur">
                  <div className="tooltips">
                    <Popover id="popover-basic">
                      <Popover.Header as="h3">Madhupur</Popover.Header>
                      <Popover.Body>
                        <strong> Address: </strong> Vill: Tekipara, PO:Madhupur, Tangail-1996<br />
                        <strong>Phone: </strong>01730351136
                      </Popover.Body>
                    </Popover>
                  </div>
                </div>
                <div className="invisible-area sylhet">
                  <div className="tooltips-sylhet">
                    <Popover id="popover-basic">
                      <Popover.Header as="h3">Sylhet</Popover.Header>
                      <Popover.Body>
                        <strong> Address: </strong> Pirer Bazar (Petrol Pump), Upazilla: Khadimnagor, Sylhet-3310<br />
                        <strong>Phone: </strong>01730350971
                      </Popover.Body>
                    </Popover>
                  </div>
                </div>
                <div className="invisible-area sreemangal">
                  <div className="tooltips-sreemangal">
                    <Popover id="popover-basic">
                      <Popover.Header as="h3">Sreemangal</Popover.Header>
                      <Popover.Body>
                        <strong> Address: </strong> Uttar Uttarsur, Habigonj Road, Sreemongol, Moulvibazar-3200<br />
                        <strong>Phone: </strong> 01730351129
                      </Popover.Body>
                    </Popover>
                  </div>
                </div>
                <div className="invisible-area-uttara uttara">
                  <div className="tooltips">
                    <Popover id="popover-basic">
                      <Popover.Header as="h3">Uttara</Popover.Header>
                      <Popover.Body>
                        <strong> Address: </strong> Ashkona, Dokshin Khan (Beside Hajj Camp) Dhaka-1230<br />
                        <strong>Phone: </strong> 01787669659
                      </Popover.Body>
                    </Popover>
                  </div>
                </div>
                <div className="invisible-area-gulshan gulshan">
                  <div className="tooltips">
                    <Popover id="popover-basic">
                      <Popover.Header as="h3">Gulshan</Popover.Header>
                      <Popover.Body>
                        <strong> Address: </strong> H-96&98, Rd-10/2, Block-D, Niketon, Gulshan, Dhaka-1212<br />
                        <strong>Phone: </strong> 01729071001
                      </Popover.Body>
                    </Popover>
                  </div>
                </div>
                <div className="invisible-area cumilla">
                  <div className="tooltips">
                    <Popover id="popover-basic">
                      <Popover.Header as="h3">Cumilla</Popover.Header>
                      <Popover.Body>
                        <strong> Address: </strong> Sreepur, Rajendrapur, Bishaw Road, Cumilla-3500<br />
                        <strong>Phone: </strong> 01730350365
                      </Popover.Body>
                    </Popover>
                  </div>
                </div>
                <div className="invisible-area-faridpur faridpur">
                  <div className="tooltips">
                    <Popover id="popover-basic">
                      <Popover.Header as="h3">Faridpur</Popover.Header>
                      <Popover.Body>
                        <strong> Address: </strong> Domrakandi (New Krishi College) PO: Komarpur, Faridpur-7800<br />
                        <strong>Phone: </strong>01729071427
                      </Popover.Body>
                    </Popover>
                  </div>
                </div>
                <div className="invisible-area-jashore jashore">
                  <div className="tooltips">
                    <Popover id="popover-basic">
                      <Popover.Header as="h3">Jashore</Popover.Header>
                      <Popover.Body>
                        <strong> Address: </strong> Dormatola, City Bipass, Jashore-7400<br />
                        <strong>Phone: </strong> 01730351139
                      </Popover.Body>
                    </Popover>
                  </div>
                </div>
                <div className="invisible-area khulna">
                  <div className="tooltips">
                    <Popover id="popover-basic" >
                      <Popover.Header as="h3">Khulna</Popover.Header>
                      <Popover.Body>
                        <strong> Address: </strong> H-25, Rd-171, Central West Block, Khalishpur, Khulna-9000<br />
                        <strong>Phone: </strong> 01730329571
                      </Popover.Body>
                    </Popover>
                  </div>
                </div>
                <div className="invisible-area barishal">
                  <div className="tooltips">
                    <Popover id="popover-basic">
                      <Popover.Header as="h3">Barishal</Popover.Header>
                      <Popover.Body>
                        <strong> Address: </strong> Vill: Kalasgram,PO: East Pagsha, Barishal-8200<br />
                        <strong>Phone: </strong>01730347935
                      </Popover.Body>
                    </Popover>
                  </div>
                </div>
                <div className="invisible-area chattogram">
                  <div className="tooltips-ctg">
                    <Popover id="popover-basic">
                      <Popover.Header as="h3">Chattogram</Popover.Header>
                      <Popover.Body>
                        <strong> Address: </strong> 18 S.S. Khaled Road, Kazir Dewri, Chattogram-4000<br />
                        <strong>Phone: </strong>01730351133
                      </Popover.Body>
                    </Popover>
                  </div>
                </div>
                <div className="invisible-area coxsbazar">
                  <div className="tooltips-cox">
                    <Popover id="popover-basic">
                      <Popover.Header as="h3">Cox's Bazar</Popover.Header>
                      <Popover.Body>
                        <strong> Address: </strong> Marine Driveway, Kalatali Road, Cox's Bazar-4700<br />
                        <strong>Phone: </strong>01730351128
                      </Popover.Body>
                    </Popover>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </MediaQuery>

        <MediaQuery maxWidth={600}>
          <Col lg={6} sm={12}>
            <div>
              <img
                style={{ width: '100%' }}
                src='https://storage.googleapis.com/blcstoreone/blcimage/bd-map-new-three.png' alt="blc map" />
            </div>
          </Col>
        </MediaQuery>

      </Row>
    </Container>
    </section>
  );
};
export default Blc_map;